import { connect } from "react-redux";
import React, { useState, useEffect } from "react";
import { Icons, Button, Tooltip } from "@texada/ui";
// Suppressed for now, see James or Ani
// import QuickbarCreate from "./quickbar/QuickbarCreate";
import QuickbarHelp from "./quickbar/QuickbarHelp";
import QuickbarUser from "./quickbar/QuickbarUser";
import "./NavBar.scss";

const NavBar: React.FC<{
  userName: string;
  user: {
    upgraded: boolean,
    userinstance: {
      current: {
        name: string
      }
    }
  };
  toggleButtonOnClick: () => void;
}> = ({user, userName, toggleButtonOnClick}) => {
  const [isQuickbarOpen, setIsQuickbarOpen] = useState("false");
  const [companyName, setCompanyName] = useState("")

  useEffect(() => {
    if(user.upgraded) {
      setCompanyName(user?.current_company?.title)
      return
    }
    setCompanyName(user.company_title)
  }, [user])

  return (
    <div className="navbar">
      <div className="navbar-left" id="header-content">
        <span className="menu-toggle" onClick={toggleButtonOnClick}>
          <Icons.Menu />
        </span>
      </div>

      <div className="navbar-quickbar">
        {/*
        // Suppressed for now, see James or Ani
        <Tooltip label="Create">
          <Button
            outline
            icon={{ render: Icons.Add }}
            onClick={() => {
              setIsQuickbarOpen("create");
            }}
            size="lg"
          />
        </Tooltip> */}

        <Tooltip label="Help and Feedback">
          <Button
            outline
            icon={{ render: Icons.HelpOutline }}
            onClick={() => {
              setIsQuickbarOpen("help");
            }}
            size="lg"
          />
        </Tooltip>

        <Tooltip label="User and Settings">
          <div className="quickbar-user-btn">
            <Button
              outline
              icon={{ render: Icons.AccountCircle }}
              onClick={() => {
                setIsQuickbarOpen("user");
              }}
            >
              <span
                className={`quickbar-indicator quickbar-indicator--${
                  localStorage.ClockInValue ? "green" : "red"
                }`}
              ></span>
              <div className="quickbar-user-btn-name">
                <span>{userName}</span>
                <span>{companyName}</span>
              </div>
            </Button>
          </div>
        </Tooltip>

        {/*
        // Suppressed for now, see James or Ani
        <QuickbarCreate
          isOpen={isQuickbarOpen === "create"}
          onCancel={() => setIsQuickbarOpen("false")}
          setIsQuickbarOpen={setIsQuickbarOpen}
        /> */}

        <QuickbarHelp
          isOpen={isQuickbarOpen === "help"}
          onCancel={() => setIsQuickbarOpen("false")}
        />

        <QuickbarUser
          isOpen={isQuickbarOpen === "user"}
          onCancel={() => setIsQuickbarOpen("false")}
          setIsQuickbarOpen={setIsQuickbarOpen}
        />
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  const userName = JSON.parse(localStorage.getItem("isOperator"))
    ? "(SCS) " + state.auth?.user?.name
    : state.auth?.user?.name;

  return {
    userName: userName,
    user: state.auth.user
  };
};

export default connect(mapStateToProps)(NavBar);
